import type { ChangeEvent } from 'react';
import { isDK, type LocaleIso } from 'utils';
import { NumberInput } from '@pixum/web-input';
import type { AddressFormData } from '../../../types';

interface PickupPointFieldsProps {
  formData: AddressFormData;
  constants: Record<string, string>;
  fieldError: (name: string) => string | undefined;
  fieldName: (name: string) => string;
  formId?: string;
  locale: LocaleIso;
  onInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function PickupPointFields({
  formData,
  constants,
  fieldError,
  fieldName,
  formId,
  locale,
  onInputChange
}: PickupPointFieldsProps) {
  return (
    <>
      <NumberInput
        label={constants['i18n_postnumber_packstation']}
        form={formId}
        name={fieldName('postnummer')}
        value={formData.postnummer}
        onChange={onInputChange}
        hasError={Boolean(fieldError('postnummer'))}
        inputInfo={fieldError('postnummer')}
      />
      {!isDK(locale) && (
        <NumberInput
          label={constants['i18n_station_number_packstation']}
          form={formId}
          name={fieldName('stationNumber')}
          value={formData.stationNumber}
          onChange={onInputChange}
          hasError={Boolean(fieldError('stationNumber'))}
          inputInfo={fieldError('stationNumber')}
        />
      )}
      {isDK(locale) && (
        <>
          <input name={fieldName('streetAddOn')} type="hidden" value={formData.streetAddOn} />
          <input name={fieldName('stationNumber')} type="hidden" value={formData.stationNumber} />
        </>
      )}
    </>
  );
}
